<div class="SendMailModal">
    <mat-toolbar>
        <h3>{{ "sendCountingReport" | translate }} </h3>
    </mat-toolbar>
        <mat-dialog-content>
            <h3 fxLayout="row" fxLayoutAlign="center center" class="text-center" class="mt-15">{{ "email" | translate }}</h3>
            <form [formGroup]="form" autocomplete="off">
                <br />
                <mat-form-field appearance="outline">
                    <input matInput autocomplete="off" id="SendMailModal__input" placeholder="{{'email_address' | translate}}" required #input class="form-control" formControlName="email" (keyup)="onCheckInputEvent($event)">
                </mat-form-field>
                <div *ngIf="form.controls['email'].invalid && (form.controls['email'].dirty || form.controls['email'].touched)">
                    <div *ngIf="form.controls['email'].errors.email" class="text-red">{{"error.email" | translate}}</div>
                  </div>
            </form>
        </mat-dialog-content>
        <mat-dialog-actions>
            <button mat-dialog-close mat-button color="secondary">{{ "cancel" | translate }}</button>
            <button id="SendMailModal__submitButton" mat-button color="warn" cdkFocusInitial [disabled]="disabled" (click)="sendReportMail()">{{ "send" | translate }}</button>
        </mat-dialog-actions>
  </div>